import React from "react";
import TextAreaBox from "./TextAreaBox";

/**
 * TextAreaWithSpeech
 * ---------------------------------------------------------------------------
 * Voice-typing / dictation feature was removed by request. This wrapper now
 * passes straight through to TextAreaBox so every existing import in the
 * tree continues to render a textarea — without the microphone button or
 * the Web Speech API hook. Kept as a thin alias rather than refactoring
 * each caller to import TextAreaBox directly.
 */
const TextAreaWithSpeech = (props) => <TextAreaBox {...props} />;

export default TextAreaWithSpeech;
